/**
 * Created by USER on 18/6/25.
 */
import React, { Component } from 'react';
import {Modal} from 'antd';

export default class AgreementModal extends Component {
  render() {
    const {show, handleCancel, t} = this.props;
    return (
      <Modal
        title=""
        style={{ top: 20 }}
        visible={show}
        footer={null}
        wrapClassName="vertical-center-modal"
        onCancel={() => handleCancel()}
        destroyOnClose={true}
        width={700}
      >
        <div className="agreement_modal_content">
          <div className="agreement_notice">
            {t('use_agreement_title')}
          </div>
          <div className="agreement_secondary_title">
            {t('use_agreement_details_title1')}
          </div>
          <p>
            {t('use_agreement_details1_1')}
          </p>
          <div className="agreement_secondary_title">
            {t('use_agreement_details_title2')}
          </div>
          <p>
            {t('use_agreement_details2_1')}
          </p>
          <p>
            {t('use_agreement_details2_2')}
          </p>
          <p>
            {t('use_agreement_details2_3')}
          </p>
          <div className="agreement_secondary_title">
            {t('use_agreement_details_title3')}
          </div>
          <p>
            {t('use_agreement_details3_1')}
          </p>
          <p>
            {t('use_agreement_details3_2')}
          </p>
          <div className="agreement_secondary_title">
            {t('use_agreement_details_title4')}
          </div>
          <p>
            {t('use_agreement_details4_1')}
          </p>
          <p>
            {t('use_agreement_details4_2')}
          </p>
          <p>
            {t('use_agreement_details4_3')}
          </p>
          <div className="agreement_secondary_title">
            {t('use_agreement_details_title5')}
          </div>
          <p>
            {t('use_agreement_details5_1')}
          </p>
          <p>
            {t('use_agreement_details5_2')}
          </p>
        </div>
      </Modal>
    );
  }
}